const getBtlCarouselProductLink = ({
  products,
  product,
  isMobile,
  indexOffset = 0,
}) => {
  const indexInCarousel = products.findIndex(({ id }) => id === product.id);
  const btlType = isMobile ? "pop+up" : "content";

  if (!product?.pdpUrl) {
    return undefined;
  }
  return `${product.pdpUrl}#ctaRef-btl+${btlType}+-+btl+carousel_${
    indexInCarousel + indexOffset
  }&featureref1-btl+${btlType}+btl+carousel`;
};

export default getBtlCarouselProductLink;
